import { useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import blogsBanner from '../../../Images/Gallery.jpg';
import image01 from '../../../Images/Gallery/01.jpeg';
import image02 from '../../../Images/Gallery/02.jpeg';
import image03 from '../../../Images/Gallery/03.jpeg';
import image04 from '../../../Images/Gallery/04.jpeg';
import image05 from '../../../Images/Gallery/05.jpeg';
import image06 from '../../../Images/Gallery/06.jpeg';
import image07 from '../../../Images/Gallery/07.jpeg';
import image08 from '../../../Images/Gallery/08.jpeg';
import image09 from '../../../Images/Gallery/09.jpeg';
import image10 from '../../../Images/Gallery/10.jpeg';
import image11 from '../../../Images/Gallery/11.jpeg';
import image12 from '../../../Images/Gallery/12.jpeg';
import image13 from '../../../Images/Gallery/13.jpeg';
import image14 from '../../../Images/Gallery/14.jpeg';
import image15 from '../../../Images/Gallery/15.jpeg';
import image16 from '../../../Images/Gallery/16.jpeg';
import image17 from '../../../Images/Gallery/17.jpeg';
import image18 from '../../../Images/Gallery/18.jpeg';
import image19 from '../../../Images/Gallery/19.jpeg';
import image20 from '../../../Images/Gallery/20.jpeg';
import image21 from '../../../Images/Gallery/21.jpeg';
import image22 from '../../../Images/Gallery/22.jpeg';
import image23 from '../../../Images/Gallery/23.jpeg';
import image24 from '../../../Images/Gallery/24.jpeg';
import image25 from '../../../Images/Gallery/25.jpeg';
import image26 from '../../../Images/Gallery/26.jpeg';
import image27 from '../../../Images/Gallery/27.jpeg';
import image28 from '../../../Images/Gallery/28.png';

import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import SectionTitle from '../../SectionTitle/SectionTitle';
import '../About/Gallery/Gallery.css';

const slides = [
  { src: image01 },
  { src: image02 },
  { src: image03 },
  { src: image04 },
  { src: image22 },
  { src: image06 },
  { src: image11 },
  { src: image14 },
  { src: image24 },
  { src: image25 },
  { src: image26 },
  { src: image27 },
  { src: image16 },
  { src: image20 },
  { src: image15 },
  { src: image21 },
  { src: image05 },
  { src: image28 },
  { src: image07 },
  { src: image08 },
  { src: image09 },
  { src: image10 },
  { src: image12 },
  { src: image13 },
  { src: image17 },
  { src: image18 },
  { src: image19 },
  { src: image23 },
];

const AllGallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  return (
    <div>
      <Breadcrumb
        title='Our Gallery'
        subTitle='Our Gallery'
        slgs='/gllery'
        img={blogsBanner}
      ></Breadcrumb>
      <section className='pb-[80px] pt-[80px]'>
        <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
          <SectionTitle
            title="Let's Check Our Photo Gallery"
            subtitle='Our Gallery'
          />
          <div className='grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4'>
            {slides.map((img, i) => (
              <div className='gallery-item' key={i}>
                <div className='gallery-img'>
                  <img src={img.src} alt='gallery' />
                </div>

                <div className='gallery-content'>
                  <button
                    className='gallery-link'
                    onClick={() => {
                      setIndex(i);
                      setOpen(true);
                    }}
                  >
                    <FaPlus />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Lightbox */}
          <Lightbox
            open={open}
            close={() => setOpen(false)}
            index={index}
            slides={slides}
          />
        </div>
      </section>
    </div>
  );
};

export default AllGallery;
